const baseMetrics = {
  UNITS: {
    normal: ['quantity_sold_1', 'quantity_sold_2'],
    var: ['quantity_sold'],
    varResponse: ['quantity_sold_var']
  },
  PESOS: {
    normal: ['real_sales_amount_1', 'real_sales_amount_2'],
    var: ['real_sales_amount'],
    varResponse: ['real_sales_amount_var']
  }
}

export {baseMetrics}



// WEBPACK FOOTER //
// ./src/expertoRetail/library/commonParameters.js